export default __webpack_public_path__ + "static/media/avatar00.7d514d92.svg";